// Central business info — update here once, reflected everywhere (UI + SEO).
export const SITE = {
  name: "GOOD RIDES LA",
  legalName: "GOOD RIDES",
  driver: "Ece Czerw",
  url: "https://goodridesla.com",
  phone: "+13109265298",
  phoneDisplay: "+1 (310) 926-5298",
  whatsapp: "13109265298",
  email: "ece@goodrides.com",
  city: "Los Angeles",
  region: "CA",
  country: "US",
  geo: { lat: 34.0522, lng: -118.2437 },
  social: {
    instagram: "https://instagram.com/goodrides.la",
    facebook: "https://facebook.com/goodrides.la",
  },
  rating: { value: 4.9, count: 500 },
} as const;

export const whatsappLink = (message?: string) =>
  `https://wa.me/${SITE.whatsapp}${
    message ? `?text=${encodeURIComponent(message)}` : ""
  }`;
